import { Card, CardBody } from '@vnetwork/ui/primitives';
import { Section } from '@vnetwork/ui/layout';
import styles from './JobDetailRuntimeCard.module.css';

interface Props {
  priority?: string | number | null;
  gpu?: boolean | null;
  sourceType?: string | null;
  inputFile?: string | null;
  pullFrom?: string | null;
  distributeTo?: string[];
}

export function JobDetailRuntimeCard({
  priority,
  gpu,
  sourceType,
  inputFile,
  pullFrom,
  distributeTo = [],
}: Props) {
  const rows: { label: string; value: string }[] = [
    { label: 'Source type', value: sourceType || '—' },
    { label: 'Input file', value: inputFile || '—' },
    { label: 'Pull from', value: pullFrom || '—' },
    { label: 'Priority', value: priority != null ? String(priority) : '—' },
    { label: 'GPU transcoding', value: gpu ? 'Yes' : 'No' },
  ];

  return (
    <Section title="Runtime Settings" description="Source ingestion and distribution configuration." style={{ marginBottom: 0 }}>
      <Card flat>
        <CardBody>
          <dl className={styles.fieldList}>
            {rows.map((r) => (
              <div key={r.label} className={styles.fieldRow}>
                <dt className={styles.fieldLabel}>{r.label}</dt>
                <dd className={styles.fieldValue}>{r.value}</dd>
              </div>
            ))}
            {distributeTo.length > 0 && (
              <div className={styles.fieldRow}>
                <dt className={styles.fieldLabel}>Distribute to</dt>
                <dd className={styles.fieldValue}>
                  <ul className={styles.distributeList}>
                    {distributeTo.map((d, i) => <li key={i}>{d}</li>)}
                  </ul>
                </dd>
              </div>
            )}
          </dl>
        </CardBody>
      </Card>
    </Section>
  );
}
